import * as Ids from '@utils/ids';
import request from '@utils/axiosWrapper';

/**
 * 订单回执上报（push/轮询，开启自动接单的门店会上报）
 */
const recordReceiptInfo = (
    orderList: Array<{ wmPoiId: string; wmOrderViewId: string }>,
    isFromPush: boolean,
) => {
    request
        .postAsFormSubmit('/v2/order/receive/unprocessed/w/mreceipt', {
            orderInfoPair: JSON.stringify(orderList),
            acctId: Ids.getAcctId(),
            appType: '3',
            token: Ids.getToken(),
            isFromPush,
            isRefreshPage: 0,
        })
        .then(
            // 无论成功失败，均不处理
            // NOTE: 线上存在脏数据，影响告警
            () => null,
            () => null,
        );
};

// eslint-disable-next-line import/prefer-default-export
export { recordReceiptInfo };
